/**
 * Language code to country code (ISO 3166-1 alpha-2) mapping.
 * Mostly ISO 639-1 language codes, plus documented InterPals two-character extensions.
 * Used with flag-icons library for displaying language flags
 *
 * NOTE: This mapping is also defined in PHP at app/Helpers/LinksHelper.php
 * for server-side rendering. Keep both in sync when making changes.
 */
export const LANG_TO_COUNTRY = {
    'EN': 'gb', 'ES': 'es', 'FR': 'fr', 'DE': 'de', 'PT': 'pt',
    'IT': 'it', 'ZH': 'cn', 'JA': 'jp', 'KO': 'kr', 'RU': 'ru',
    'AR': 'sa', 'HI': 'in', 'NL': 'nl', 'PL': 'pl', 'TR': 'tr',
    'VI': 'vn', 'TH': 'th', 'UK': 'ua', 'EL': 'gr', 'CS': 'cz',
    'SV': 'se', 'DA': 'dk', 'FI': 'fi', 'NO': 'no', 'HU': 'hu',
    'RO': 'ro', 'ID': 'id', 'MS': 'my', 'HE': 'il', 'FA': 'ir',
    'BG': 'bg', 'HR': 'hr', 'SK': 'sk', 'SL': 'si', 'LT': 'lt',
    'LV': 'lv', 'ET': 'ee', 'IS': 'is', 'GA': 'ie', 'MT': 'mt',
    'MK': 'mk', 'SQ': 'al', 'BS': 'ba', 'SR': 'rs', 'KA': 'ge',
    'HY': 'am', 'AZ': 'az', 'KK': 'kz', 'UZ': 'uz', 'MN': 'mn',
    'NE': 'np', 'SI': 'lk', 'KM': 'kh', 'LO': 'la', 'MY': 'mm',
    'TL': 'ph', 'AF': 'za', 'AM': 'et', 'AS': 'in', 'BE': 'by',
    'BN': 'bd', 'CY': 'gb-wls', 'GU': 'in', 'KN': 'in', 'ML': 'in',
    'MR': 'in', 'OR': 'in', 'PA': 'in', 'TA': 'in', 'TE': 'in',
    'FO': 'fo', 'FJ': 'fj', 'HT': 'ht', 'HA': 'ng', 'JV': 'id',
    'KY': 'kg', 'LA': 'va', 'LB': 'lu', 'MG': 'mg', 'MI': 'nz',
    'MO': 'md', 'RW': 'rw', 'RN': 'bi', 'GD': 'gb-sct', 'SM': 'ws',
    'SO': 'so', 'SU': 'id', 'SW': 'tz', 'TG': 'tj', 'TK': 'tm',
    'UR': 'pk', 'WO': 'sn', 'XH': 'za', 'YO': 'ng', 'ZU': 'za',
    'KL': 'gl', 'SH': 'zw', 'SN': 'zw', 'NR': 'za', 'ST': 'ls', 'TN': 'bw',
    'SS': 'sz', 'TS': 'za', 'LN': 'cd', 'SD': 'pk', 'CEB': 'ph',
    'VO': 'eu', 'IA': 'eu', 'IE': 'eu', 'EO': 'eu', 'YI': 'il',
    'OM': 'et', 'TI': 'er', 'AA': 'dj', 'AY': 'bo', 'QU': 'pe',
    'GN': 'py', 'DZ': 'bt', 'BO': 'cn',
    // InterPals two-character extensions for languages without ISO 639-1 alpha-2 codes
    'AD': 'ru', 'BX': 'ru', 'CV': 'ru', 'EE': 'gh', 'FF': 'sn',
    'HW': 'us-hi', 'IG': 'ng', 'LG': 'ug', 'B2': 'in', 'ND': 'zw',
    'NY': 'mw', 'SC': 'it-88', 'VE': 'za',
    'AC': 'sy', 'HK': 'tw', 'IH': 'ru', 'NH': 'mx', 'NP': 'it-72',
    'OS': 'south_ossetia', 'S2': 'gb-sct', 'SX': 'it-82',
    'UD': 'ru-ud', 'YU': 'hk', 'KC': 'ru', 'K1': 'ru',
};

/**
 * Get country code for a language code
 * @param {string} langCode - Language code (case-insensitive)
 * @returns {string} Country code or empty string if not found
 */
export function getCountryCode(langCode) {
    if (!langCode) return '';
    return LANG_TO_COUNTRY[langCode.toUpperCase()] || '';
}
